import trinity from './themes/trinity.module.scss'
import stmellitus from './themes/stmellitus.module.scss'
import { TEI_SLUG } from '@Root/tei'

export const FORM_THEMES = {
  trinity: {
    styles: trinity,
    numberedSections: true,
    tabs: false,
    brand: null,
  },
  stmellitus: {
    styles: stmellitus,
    numberedSections: false,
    tabs: true,
    brand: 'ST MELLITUS COLLEGE',
  },
}

export const DEFAULT_FORM_THEME = 'trinity'

/** The viewer theme is branding, so it follows the build-time TEI (REACT_APP_TEI). */
export const resolveFormTheme = (slug = TEI_SLUG) => (FORM_THEMES[slug] ? slug : DEFAULT_FORM_THEME)

export const getFormTheme = slug => FORM_THEMES[resolveFormTheme(slug)]
